/**************************************************
 * Nombre:       Tarjeta_Profesional
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Chip, Grid, Typography} from "@mui/material";
import foto from '../../Recursos/foto_profesional.png'
import {theme} from "../../Tema";
import {COLORTEXTO} from "../../Constantes";
import {ArrowForward} from "@mui/icons-material";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {useNavigate} from "react-router";


const Tarjeta_Profesional = ({item}) => {
    const {Aviso, abrirAviso} = useIrRuta()
    const navigate = useNavigate();

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}

        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundImage: 'linear-gradient(247deg, rgba(0, 0, 0, 0.80) 3.73%, rgba(115, 115, 115, 0.00) 60.47%), url(' + foto + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                    borderTopRightRadius: 20,
                    borderTopLeftRadius: 20,
                    p: 3
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    {item.valor &&
                        <Chip color={'secondary'} label={`${formatoMoneda(item.valor)}/Hr`}
                              sx={{fontWeight: 800, pt: 0.1}}/>
                    }
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-end'}}>

                    <Typography sx={{
                        color: theme.palette.secondary.main,
                        fontWeight: 600,
                        fontSize: 14,
                        textAlign: 'right',
                        lineHeight: 1.2
                    }}>
                        {item.disponible && 'Disponible Esta Semana'}
                    </Typography>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-end'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={2}
                    sx={{mt: 20}}
                >

                    {item && item.servicios.map((it) => {
                        return (
                            <Chip color={'primary'} label={it} sx={{fontWeight: 600}}/>
                        )
                    })}


                </Grid>


            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    p: 3,
                    backgroundColor: '#fff',
                    borderBottomLeftRadius: 20,
                    borderBottomRightRadius: 20,

                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{color: COLORTEXTO, fontSize: 24, fontWeight: 600, lineHeight: 1.1}}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',mt: 1}}>
                    <Typography sx={{color: theme.palette.primary.main, fontSize: 18, fontWeight: 600}}>
                        {item.profesion}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                    <Button
                        onClick={() => navigate('/Profesional')}
                        variant={'text'} endIcon={<ArrowForward/>}
                            sx={{px: 0, fontSize: 12, color: COLORTEXTO}}
                    >VER PERFIL</Button>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Tarjeta_Profesional    